export const SOURCE = {
    OLX: 'olx',
    OLXAUTOS: 'olxAutos',
    VALUATION_FLOW: 'valuationFlow',
    BUYER_INTENT: 'buyerIntent',
    LETGO_AUTOS: 'letgoAutos',
    SELL_THEMATIC_PAGE: 'sellThematicPage'
};

export const TRACKING_ORIGINS = {
    HP_DIRECT: 'homepage_widget',
    ORGANIC_DIRECT: 'organic_direct'
};

export const VALUATION_FLOW_ROUTE = '/valuation-flow';

export const SELL_OLD_CAR_ROUTE = 'sell';

export const CALLBACK_ASSISTED_SI_HOME = 'callback_assisted_si_home';
